import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Identity from './components/Identity/Identity';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './components/common/ThemeContext';
import { ToasterProvider } from './components/common/Toaster';
import LocationReporter from './components/common/LocationReporter';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <ThemeProvider>
        <ToasterProvider>
          <BrowserRouter>
            <LocationReporter />
            <Routes>
              <Route path="/identity" element={<Identity />} />
              <Route path="/*" element={<App />} />
            </Routes>
          </BrowserRouter>
        </ToasterProvider>
      </ThemeProvider>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
